module.exports = __webpack_public_path__ + "img/图片2-1.bcde4eba.png";